import React from 'react';
import './ConfirmBar.css';

const ConfirmBar = ({
  message,
  highlight,
  onConfirm,
  onCancel,
  confirmLabel = 'Oui, confirmer',
  cancelLabel  = 'Annuler',
}) => {
  return (
    <div className="dt-confirm-bar">
      <span>
        {message} {highlight && <strong>{highlight}</strong>} ?
      </span>
      <button className="dt-btn-confirm" onClick={onConfirm}>
        {confirmLabel}
      </button>
      <button className="dt-btn-cancel" onClick={onCancel}>
        {cancelLabel}
      </button>
    </div>
  );
};

export default ConfirmBar;